import React, { createContext, useState, useContext, useEffect } from 'react';
import { MyContext } from './ProviderContext';

export const About=()=>
{
    
        const { menuComponent, setMenuComponent } = useContext(MyContext);
    
        useEffect(() => {
            setMenuComponent({home:'',about:'active', services:'',team:'',contact:'',project:''});
        }, [])

    return(
<>

            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>About Us</h2>
                        </div>
                        <div className="col-12">
                            <a href="/">Home</a>
                            <a href="">About Us</a>
                        </div>
                    </div>
                </div>
            </div>
          
            <div className="about wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="about-img">
                                <img src="img/about.jpg" alt="Image" />
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <div className="section-header text-left">
                                <p>Welcome to Frantino</p>
                                <h2>Multiple Years Of Positive Impact</h2>
                            </div>
                            <div className="about-text">
                                <p>
                                    Frantino Multiple Services Limited (FMSL) is an ISO 9001:2015 certified Company. A forward thinking multi-disciplinary indigenous company incorporated in Nigeria for the provision of broad-based Engineering, Procurement and Construction (EPC) Services.
                                </p>
                                <p>
                                    Incorporated in 2010, FRANTINO has provided satisfactory services to major clients like Nigerian Agip Oil Company Ltd, Indorama Petrochemicals, Seplat Energy Plc. etc. We have grown into a vastly integrated company, which has led to the formation of FRANTINO GROUP, with the incorporation of Frantino Construction Company Ltd, Frantino Petroleum Ltd, Frantino Steels Ltd, Frantino Farms Ltd and Frantino Petroleum Trading LLC in the U.A.E.
                                </p>
                                <p>
                                <i>FRANTINO</i> is managed by highly qualified and experienced professionals. Our technical team has successfully carried out many jobs in the past and combines several years of experience gained from different Industry sectors, to consistently deliver broad range high quality services and industry solutions. We are a privately held organization, anchored by loyal employees who are dedicated to providing superior services and grounded in the philosophy that honesty and integrity are very important… the reason why FRANTINO enjoys an impeccable reputation. We have never failed to complete a project. Schedules and budgets are meant to be kept and strive every day to do so
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="feature wow fadeInUp" data-wow-delay="0.1s">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-worker"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>HSE</h3>
                                    <p>Excellent safety records in projects, and safety awards from our clients keeps us motivated</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-building"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>Exceptional Service</h3>
                                    <p>The quality of our services is the reason our clients recommend us</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-call"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>Competent Workforce</h3>
                                    <p>With certified engineers, and technicians our services are highly sort after in the industry</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</>

    )
}